import axios from "axios";
import store from '../vuex/store'
// 访问记录
const visitRecord = function (path) {
  let type = '1';
  let tbId = null;
  if (path) {
    if (path.indexOf('home') != -1 || path=="/") {
      type = '1';
    } else if (path.indexOf('teamBuilding') != -1 && path.indexOf('teamBuildingDetail') == -1) {
      type = '2';
    } else if (path.indexOf('teamBuildingDetail') != -1) {
      type = '3';
      let array = path.split('?id=');
      if (array && array.length > 1) {
        tbId = array[1];
      }
    } else if (path.indexOf('annualMeetingPage') != -1) {
      type = '4';
    } else if (path.indexOf('caseList') != -1) {
      type = '5';
    } else if (path.indexOf('internalTrainingList') != -1) {
      type = '6';
    }
    const prePath = "http://www.lxqtj.com/#";
    path = prePath + path;
  }
  let params = {
    deviceType: '1',
    cityId: store.state.locationSiteCity,
    type,
    path,
    tbId
  }
  console.log(params);
  axios
    .post(`/api/detailVisit/visitRecord`, JSON.stringify(params), {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    }).then((res) => {
      if (res.data && res.data.code == 200) {
        console.log(res);
      }
    }).catch(e => {
    });
}

export { visitRecord }




// WEBPACK FOOTER //
// ./src/router/api.js